import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import classes from './Drawer.module.scss'

const DrawerPicker = ({ title, onCancel, children }) => {
  const { t } = useTranslation()

  return (
    <div className={classes.picker}>
      <div className={`${classes.pickerHeader} d-flex align-items-center justify-content-between`}>
        <span>{title}</span>
        <button className={classes.textButton} onClick={onCancel}>{t('common.cancel')}</button>
      </div>
      <div className={`${classes.pickerBody} d-flex flex-column`}>{children}</div>
    </div>
  )
}

DrawerPicker.propTypes = {
  title: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default DrawerPicker
